import { render, staticRenderFns } from "./DomainsSwitcher.vue?vue&type=template&id=17fd62b0&scoped=true"
import script from "./DomainsSwitcher.vue?vue&type=script&lang=js"
export * from "./DomainsSwitcher.vue?vue&type=script&lang=js"
import style0 from "./DomainsSwitcher.vue?vue&type=style&index=0&id=17fd62b0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17fd62b0",
  null
  
)

export default component.exports